import { put, takeEvery, all, select, putResolve } from "redux-saga/effects";
import { GET_AVVISI_UTENTE, GET_PRESA_VISIONE, GET_PROFILO, GET_ULTIMA_INFORMATIVA, PATCH_PROFILO, POST_PRESA_VISIONE, POST_PROFILO, } from "./actionsType";
import { getAvvisiUtenteActionSuccess, getPresaVisioneActionSuccess, getProfiloActionSuccess, getUltimaInformativaActionSuccess, patchProfiloAction, patchProfiloActionSuccess, postPresaVisioneAction, postPresaVisioneActionSuccess, postProfiloAction, postProfiloActionSuccess } from "./actions";
import { LOADING, LOADING_BLOCKING } from "../../global/statusLabels";
import { TIMEOUT } from "../../api/api";
import { presaVisioneSelector } from "./selectors";
import { resetMessaggioStateAction, setMessaggioAction, setSnackbarAction } from "../messaggio/actions";
import { ERRORE_GENERICO_API, ERRORE_SESSION_EXPIRED, OPERATION_ERROR, OPERATION_SUCCEDED } from "../../global/messaggioLabels";
import { ESITI, PRIVACY, SCREENINGCOLONRETTO } from "../../global/urlMapping";
import { campagnaSelector } from "../persistentStore/selectors";
import { checkScreeningCLAction } from "../screeningColonRetto/actions";
import { checkScreeningMXAction } from "../screeningMammografico/actions";
import { getScreeningResultAction } from "../screening/actions";
import { getPresaVisioneApiTS, getPresaVisioneSPID, getProfiloApiSPID, getProfiloApiTS, getUltimaInformativaApiTS, patchProfiloApiSPID, patchProfiloApiTS, postPresaVisioneApiTS, postPresaVisioneApiSPID, postProfiloApiSPID, postProfiloApiTS, getAvvisiUtenteApiTS } from "../../api/apiFunctionsProfilazione";
import { profiloAriannaSelector } from "../screening/selectors";
import { generaLog } from "../../functions/utils";
import { ASL_3, ASL_5 } from "../../global/multiAsl";


function* getProfiloWorker() {
    generaLog("getProfiloWorker", "log")
    yield put(getProfiloActionSuccess({ value: undefined, status: LOADING }))

    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield getProfiloApiTS()
        } else {
            response = yield getProfiloApiSPID()

        }
        //200 profilo presente, 204 profilo non presente
        yield put(getProfiloActionSuccess({ value: response?.data, status: response?.status }))
        const profiloArianna = yield select(profiloAriannaSelector)
        const profilo = {
            'codiceFiscale': profiloArianna?.value?.patient?.fiscalCode,
            'nome': profiloArianna?.value?.patient?.patientGivenName,
            'cognome': profiloArianna?.value?.patient?.patientFamilyName,
            'contatti': {
                "email": profiloArianna?.value?.patient?.personalEmail,
                "telefono": profiloArianna?.value?.patient?.personalMobile,
                'indirizzo': profiloArianna?.value?.patient?.residenceAddress + " " + profiloArianna?.value?.patient?.residenceZipCode + " " + profiloArianna?.value?.patient?.residenceMunicipalityCode
            }
        }

        if (response?.status === 204) {//se profilo non presente
            yield putResolve(postProfiloAction(profilo))//creo profilo
        } else if (response?.status === 200) {//se profilo presente
            yield putResolve(patchProfiloAction(profilo))//salvo profilo
        }



    } catch (error) {
        if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(getProfiloActionSuccess({ value: error?.response?.data, status: error?.response?.status }))

    }
}

function* getProfiloWatcher() {
    yield takeEvery(GET_PROFILO, getProfiloWorker);
}

function* postProfiloWorker(profilo) {
    generaLog("postProfiloWorker", "log")
    yield put(postProfiloActionSuccess({ value: undefined, status: LOADING }))
    let response;
    try {
        if (sessionStorage.CFTNS) {

            response = yield postProfiloApiTS(profilo.profilo)
        } else {
            response = yield postProfiloApiSPID(profilo.profilo)

        }
        if (response?.status === 200) {
            yield put(postProfiloActionSuccess({ value: response?.data, status: response?.status }))
            yield putResolve(postPresaVisioneAction())
        }
    } catch (error) {
        if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        }
        yield put(postProfiloActionSuccess({ value: undefined, status: error?.response?.status }))

    }
}

function* postProfiloWatcher() {
    yield takeEvery(POST_PROFILO, postProfiloWorker);
}

function* patchProfiloWorker(profilo) {
    generaLog("patchProfiloWorker", "log")
    yield put(patchProfiloActionSuccess({ value: undefined, status: LOADING }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield patchProfiloApiTS(profilo.profilo)
        } else {
            response = yield patchProfiloApiSPID(profilo.profilo)

        }
        if (response?.status === 200) {
            yield put(patchProfiloActionSuccess({ value: response?.data, status: response?.status }))
            yield putResolve(postPresaVisioneAction())
        }
    } catch (error) {
        if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        }
        yield put(patchProfiloActionSuccess({ value: error?.response?.data, status: error?.response?.status }))

    }
}

function* patchProfiloWatcher() {
    yield takeEvery(PATCH_PROFILO, patchProfiloWorker);
}

function* getPresaVisioneWorker() {
    generaLog("getPresaVisioneWorker", "log")
    const campagna = yield select(campagnaSelector)
    yield put(getPresaVisioneActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING_BLOCKING, timeout: TIMEOUT }))
    let response;
    try {
        if (sessionStorage.CFTNS) {
            response = yield getPresaVisioneApiTS()
        } else {
            response = yield getPresaVisioneSPID()

        }
        yield put(getPresaVisioneActionSuccess({ value: response?.data, status: response?.status }))

        if (response?.status === 200) {
            generaLog("Preso visione", "log")
            yield put(getPresaVisioneActionSuccess({ value: response?.data, status: response?.status }))
            if (campagna === "CL")
                yield putResolve(checkScreeningCLAction())
            else if (campagna === "MX")
                yield putResolve(checkScreeningMXAction())
            else if (campagna === "ESITI")
                yield putResolve(getScreeningResultAction())
            //TODO salva profilo?  
        }
        if (response?.status === 204) {
            generaLog("No preso visione - profilo presente", "log")
            yield put(getPresaVisioneActionSuccess({ value: response?.data, status: response?.status }))
            window.location.href = PRIVACY
        }

    } catch (error) {
        yield put(getPresaVisioneActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
        if (error?.response?.status === 404 || error?.response?.status === 400) {
            generaLog("No preso visione - profilo non presente", "log")
            window.location.href = PRIVACY
        } else if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        }
        else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
    }
}

function* getPresaVisioneWatcher() {
    yield takeEvery(GET_PRESA_VISIONE, getPresaVisioneWorker);
}

function* getUltimaInformativaWorker() {
    generaLog("getUltimaInformativaWorker", "log")
    yield put(getUltimaInformativaActionSuccess({ value: undefined, status: LOADING }))
    yield put(setMessaggioAction({ status: LOADING }))
    let responseAsl3, responseAsl5;
    try {
        responseAsl3 = yield getUltimaInformativaApiTS(ASL_3.codice)
        responseAsl5 = yield getUltimaInformativaApiTS(ASL_5.codice)
        if (responseAsl3?.status === 200 && responseAsl5?.status === 200) {

            const privacy =
            {
                ASL_3: responseAsl3.data,
                ASL_5: responseAsl5.data,
            }


            yield put(getUltimaInformativaActionSuccess({ value: privacy, status: 200 }))
            yield put(resetMessaggioStateAction())
        }
        else
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
    } catch (error) {
        if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(getUltimaInformativaActionSuccess({ value: error?.response?.data, status: error?.response?.status }))

    }
}

function* getUltimaInformativaWatcher() {
    yield takeEvery(GET_ULTIMA_INFORMATIVA, getUltimaInformativaWorker);
}

function* postPresaVisioneWorker() {
    generaLog("postPresaVisioneWorker", "log")
    const campagna = yield select(campagnaSelector)
    const presaVisione = yield select(presaVisioneSelector)
    const profiloArianna = yield select(profiloAriannaSelector)
    yield put(setMessaggioAction({ status: LOADING }))
    yield put(postPresaVisioneActionSuccess({ value: undefined, status: LOADING }))
    const profilo = {
        'codiceFiscale': profiloArianna?.value?.patient?.fiscalCode,
        'nome': profiloArianna?.value?.patient?.patientGivenName,
        'cognome': profiloArianna?.value?.patient?.patientFamilyName,
        'contatti': {
            "email": profiloArianna?.value?.patient?.personalEmail,
            "telefono": profiloArianna?.value?.patient?.personalMobile,
            'indirizzo': profiloArianna?.value?.patient?.residenceAddress + " " + profiloArianna?.value?.patient?.residenceZipCode + " " + profiloArianna?.value?.patient?.residenceMunicipalityCode
        }
    }

    try {
        let responsePostProfilo;
        let responsePatchProfilo;
        let responsePostPresaVisione;

        if (presaVisione?.status === 400 || presaVisione?.status === 404) {//profilo non presente
            //post -> fa in automatico la presa visione il be
            try {
                if (sessionStorage.CFTNS) {
                    responsePostProfilo = yield postProfiloApiTS(profilo)
                } else {
                    responsePostProfilo = yield postProfiloApiSPID(profilo)
                }
            } catch (error) {
                if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
                    yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
                }
                else {
                    yield put(postPresaVisioneActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
                    yield put(resetMessaggioStateAction())
                    yield put(setSnackbarAction(OPERATION_ERROR))
                }
            }
            if (responsePostProfilo?.status === 200) {
                yield put(postPresaVisioneActionSuccess({ value: responsePostProfilo?.data, status: responsePostProfilo?.status }))
                yield put(resetMessaggioStateAction())
                yield put(setSnackbarAction(OPERATION_SUCCEDED))
                if (campagna === 'CL')
                    window.location.href = SCREENINGCOLONRETTO
                else if (campagna === 'ESITI') {
                    window.location.href = ESITI
                }

            }
        } else if (presaVisione?.status === 204) {//profilo presente
            //patch
            if (sessionStorage.CFTNS) {
                responsePatchProfilo = yield patchProfiloApiTS(profilo)
            } else {
                responsePatchProfilo = yield patchProfiloApiSPID(profilo)
            }
            //prendo visione
            if (responsePatchProfilo?.status === 200) {
                try {
                    if (sessionStorage.CFTNS) {
                        responsePostPresaVisione = yield postPresaVisioneApiTS()
                    } else {
                        responsePostPresaVisione = yield postPresaVisioneApiSPID()
                    }
                } catch (error) {
                    if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
                        yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
                    }
                    else {
                        yield put(postPresaVisioneActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
                        yield put(resetMessaggioStateAction())
                        yield put(setSnackbarAction(OPERATION_ERROR))
                    }
                }
                if (responsePostPresaVisione?.status === 200) {
                    yield put(postPresaVisioneActionSuccess({ value: responsePostProfilo?.data, status: responsePostProfilo?.status }))
                    yield put(resetMessaggioStateAction())
                    yield put(setSnackbarAction(OPERATION_SUCCEDED))
                    if (campagna === 'CL')
                        window.location.href = SCREENINGCOLONRETTO
                    else if (campagna === 'ESITI') {
                        window.location.href = ESITI
                    }
                }
            }
        }
    } catch (error) {
        if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            yield put(setMessaggioAction({ status: ERRORE_GENERICO_API }))
        }
        yield put(postPresaVisioneActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
    }


}

function* postPresaVisioneWatcher() {
    yield takeEvery(POST_PRESA_VISIONE, postPresaVisioneWorker);
}

function* getAvvisiUtenteWorker() {
    generaLog("getAvvisiUtenteWorker", "log")
    yield put(getAvvisiUtenteActionSuccess({ value: undefined, status: LOADING }))
    let response;
    try {
        response = yield getAvvisiUtenteApiTS()
        yield put(getAvvisiUtenteActionSuccess({ value: response?.data, status: 200 }))
    } catch (error) {
        if (error === ERRORE_SESSION_EXPIRED || error?.response?.status === 409) {
            yield put(setMessaggioAction({ status: ERRORE_SESSION_EXPIRED }))
        } else {
            generaLog("Errore avvisi utente", "log")
        }
        yield put(getAvvisiUtenteActionSuccess({ value: error?.response?.data, status: error?.response?.status }))
    }
}

function* getAvvisiUtenteWatcher() {
    yield takeEvery(GET_AVVISI_UTENTE, getAvvisiUtenteWorker);
}

export function* profilazioneWatchers() {
    yield all([
        getProfiloWatcher(),
        postProfiloWatcher(),
        patchProfiloWatcher(),
        getPresaVisioneWatcher(),
        getUltimaInformativaWatcher(),
        postPresaVisioneWatcher(),
        getAvvisiUtenteWatcher(),
    ]);
}